import React, { useEffect, useState } from 'react'

import { pagePrivileges } from 'lib/authorization/PagePrivileges'
import { useAppSelector } from 'redux/Hook'
import type { PageType } from 'types/Page'
import NotFound from 'components/Shared/ErrorPages/404'
import UnAuthorized from 'components/Shared/ErrorPages/401'
import { Participant } from 'lib/authorization/Roles'

type ProtectedRouteType = {
  children: JSX.Element
  name: string | undefined
}

const ProtectedRoute = ({ children, name }: ProtectedRouteType) => {
  const { doneFetching, user } = useAppSelector((state) => state.user)
  const [isValidUser, setValidUserStatus] = useState(false)
  // Local state to check if all the process are completed in the useEffect block.
  const [hasProcessedLocally, setLocalProcessStatus] = useState(false)

  /**
   * Steps to verify the admin
   *
   *  1. Check if the user data has been fetched
   *  2. Fetch the user role and validate if it has access to the page
   *  3. If in valid user then show the 404 component else set status to false
   */
  useEffect(() => {
    if (doneFetching) {
      const page: PageType[] = pagePrivileges.filter(
        (page) => page.name === name,
      )
      const roleIndex =
        page.length > 0 && page[0].allowedRoles.indexOf(user.roleName)
      const isValid = roleIndex > -1

      setValidUserStatus(isValid)
      setLocalProcessStatus(true)
    }
  }, [doneFetching, isValidUser])

  const renderComponent = () => {
    // Participants should not be able to access admin pages
    if (user.roleName === Participant) return <NotFound />

    if (isValidUser) return children
    if (hasProcessedLocally) return <UnAuthorized />

    return <></>
  }

  /**
   * If the user data has been fetched and all the local function calls are done
   * then render the route component to show either 404 or the requested page.
   * else show the black page or Spinner.
   */

  const showChildren = doneFetching && hasProcessedLocally

  return showChildren ? renderComponent() : <></>
}

export default ProtectedRoute
